<template>
  <div v-if="asset" class="gp-content">
    <content-tab-bar :tabs="tabs"></content-tab-bar>
    <transition name="fade" mode="out-in">
      <router-view :asset="asset"></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ContentTabBar from '@/components/ContentTabBar.vue';

export default {
  name: 'Asset',
  components: { ContentTabBar },
  computed: {
    ...mapState('primary', ['asset']),
    tabs() {
      return [
        {
          label: 'Dashboard',
          link: {
            name: 'assets.index.dashboard',
            params: { id: this.asset.uuid },
          },
          icon: 'dashboard',
        },
        // {
        //   label: 'Insights',
        //   link: {
        //     name: 'assets.index.detail.insights',
        //     params: { id: this.asset.uuid },
        //   },
        //   icon: 'insight',
        // },
        {
          label: 'Alerts',
          link: {
            name: 'assets.index.detail.alerts',
            params: { id: this.asset.uuid },
          },
          icon: 'alert',
        },
        {
          label: 'Logs',
          link: {
            name: 'assets.index.detail.logs',
            params: { id: this.asset.uuid },
          },
          icon: 'log',
        },
        {
          label: 'Profile',
          link: {
            name: 'assets.index.detail.profile',
            params: { id: this.asset.uuid },
          },
          icon: 'profile',
        },
        {
          label: 'Device Info',
          link: {
            name: 'assets.index.detail',
            params: { id: this.asset.uuid },
          },
          icon: 'info',
        },
        {
          label: 'Edit',
          link: {
            name: 'assets.index.detail.edit',
            params: { id: this.asset.uuid },
          },
          icon: 'edit',
        },
        {
          label: 'Delete Asset',
          link: {
            name: 'assets.index.detail.delete',
            params: { id: this.asset.uuid },
          },
          icon: 'delete',
        },
      ];
    },
  },
  beforeMount() {
    this.$store.commit('SET_ASSET', null);
  },
  async mounted() {
    await this.$store.dispatch('primary/getAsset', {
      uuid: this.$route.params.id,
    });
  },
};
</script>

<style lang="scss" scoped>

.asset-details {
  width: 100%;
}
</style>
